import { createContext, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const LangContext = createContext();

export const useLang = () => useContext(LangContext);

export const LangProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(localStorage.getItem("lang") || "ar");

  useEffect(() => {
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "en");
    }
    i18n.changeLanguage(lang);

    const handleStorageChange = (event) => {
      if (event.key === "lang") {
        setLang(event.newValue || "en");
      }
    };
    window.addEventListener("storage", handleStorageChange);

    return () => window.removeEventListener("storage", handleStorageChange);
  }, [lang, i18n]);

  const changeLanguage = (selectedLang) => {
    localStorage.setItem("lang", selectedLang);
    setLang(selectedLang);
    i18n.changeLanguage(selectedLang);
  };

  return (
    <LangContext.Provider value={{ lang, changeLanguage }}>
      {children}
    </LangContext.Provider>
  );
};

LangProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LangContext;

